module.exports = __webpack_public_path__ + "img/20240205085219623wl2.fa3f3489.jpg";